import clsx from "clsx";
import HeatmapDetails from "components/popover/HeatmapDetails";
import CustomTooltip from "components/popover/Tooltip";
import Typography from "components/Typography";
import { EncounterDetails } from "entities/issues";
import { useMemo } from "react";
import { EncounterWidth, VitalsTileHeight } from "utils/constants";
import { getGroupWidth, getLabsToDisplay } from "utils/helpers";

type LabsTileProps = {
  config: { id: number; name: string };
  groups: string[];
  encounters: Record<string, EncounterDetails[]>;
  view: "year" | "month" | "day";
};

type LabsGroupProps = {
  group: string;
  groups: string[];
  encounters: Record<string, EncounterDetails[]>;
  view: "year" | "month" | "day";
  config: { id: number; name: string };
  index: number;
};
const LabGroup = (props: LabsGroupProps) => {
  const { groups, group, encounters, view, config, index } = props;

  const encounterToShow = useMemo(() => {
    if (view == "year") return encounters[group].slice(0, 4);
    return encounters[group];
  }, [encounters, group, view]);

  return (
    <div
      className="border-y flex"
      style={{
        width:
          view == "year"
            ? `${Object.keys(encounters).length * 500}px`
            : view == "month"
            ? getGroupWidth(encounters, group)
            : encounters[group].length * EncounterWidth + 300,
        gap: view == "month" ? "24px" : "0",
      }}
    >
      {index == groups.length - 1 ? (
        <div className="flex justify-end items-center w-full pr-2 line-clamp-1">
          {config?.name}
        </div>
      ) : (
        <>
          {encounterToShow?.map((encounter, index) => {
            const values = getLabsToDisplay(encounter.labs[0], config?.name);
            return (
              <div
                key={index}
                className={clsx(
                  `w-[${EncounterWidth}px] cursor-pointer`,
                  "flex items-center justify-center text-sm",
                  { "border-x": values.name }
                )}
              >
                <CustomTooltip
                  followCursor
                  title={
                    <HeatmapDetails
                      date={encounter.date}
                      facility={encounter.facility}
                      value={values.name}
                    />
                  }
                >
                  <div
                    className={`w-[${EncounterWidth}px] h-[60px] flex items-center justify-center`}
                  >
                    <Typography
                      weight="bold"
                      htmlTag="p"
                      type="inherit"
                      clamp="clamp1"
                    >
                      {values.name}
                    </Typography>
                  </div>
                </CustomTooltip>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

const LabsTile = (props: LabsTileProps) => {
  const { config, groups, encounters, view } = props;

  return (
    <div className=" flex" style={{ height: `${VitalsTileHeight}px` }}>
      {groups?.map((item, i) => (
        <LabGroup
          key={item + i}
          group={item}
          encounters={encounters}
          view={view}
          config={config}
          index={i}
          groups={groups}
        />
      ))}
    </div>
  );
};

export default LabsTile;
